import React, { useEffect, useState } from 'react';
import PageTitle from '../../Components/PageTitle';
import  code from '../../assets/images/code.png';
import { Link } from 'react-router-dom';
import { routes } from '../../routes';
import { Accordion, Button, Card } from 'react-bootstrap';
import ContentController from '../../apis/controller/content.controller';



function Faq() {
    const [faqs, setFaqs] = useState();
    const [breadCrumbs, setBreadcrumbs] = useState();
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getFaq();
        window.scrollTo(0, 0);
    }, []);

    const getFaq = async () => {
        setLoader(true);
        let res = await new ContentController().faq();
        if (res && res.status) {
            setFaqs(res.listing);
            setBreadcrumbs(res.breadcrumb);
        }
        setLoader(false);
    };
	return (
		<>
       	{breadCrumbs ? <PageTitle title={breadCrumbs.main_title} image={breadCrumbs.image} /> : null}
        <section className="career_section">
            {faqs ?<div className="container">
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="career_detail_area">
                            <Accordion defaultActiveKey="0">
                            {faqs.map((item, index) => (
                                <Accordion.Item eventKey={index}>
                                    <Accordion.Header>
                                        {item.title}
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className="accordion-body">
                                        <p>
                                           {item.description}
                                        </p>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>: null}
        </section>
        </>
    );
}

export default Faq;